var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Platform } from 'ionic-angular';
import { OnPremiseProvider } from './on-premise';
import { WheatleyProvider } from './wheatley';
import { ModalProvider } from './popup/modal';
import { TranslateService } from '@ngx-translate/core';
/**
 * This provider acts as a wrapper
 * around the BrainBuilder API.
 */
var API = /** @class */ (function () {
    function API(http, platform, modalProvider, onPremiseProvider, wheatleyProvider, translate) {
        this.http = http;
        this.platform = platform;
        this.modalProvider = modalProvider;
        this.onPremiseProvider = onPremiseProvider;
        this.wheatleyProvider = wheatleyProvider;
        this.translate = translate;
        this.dev = false;
        this.loggedIn = false;
        this.environment = null;
        if (this.getEnvironment() == 'onpremiseelectron') {
            this.baseURL = this.onPremiseProvider.getBrainBankHostAddress();
        }
        else if (this.getEnvironment() == 'development') {
            this.baseURL = 'http://localhost:9022';
            this.dev = true;
        }
        else if (this.getEnvironment() == 'staging') {
            this.baseURL = 'https://brainbank-staging.neurala.com';
        }
        else if (this.getEnvironment() == 'releasecandidate') {
            this.baseURL = 'https://brainbank-rc.neurala.com';
        }
        else if (this.getEnvironment() == 'production') {
            this.baseURL = 'https://brainbank.neurala.com';
        }
    }
    API.prototype.getEnvironment = function () {
        if (this.environment == null) {
            if (this.onPremiseProvider.isOnPremiseElectronApp()) {
                this.environment = 'onpremiseelectron';
            }
            else if (window.location.hostname == 'localhost') {
                this.environment = 'development';
            }
            else if (window.location.hostname.includes('brainbuilder-staging.neurala.com')) {
                this.environment = 'staging';
            }
            else if (window.location.hostname.includes('brainbuilder-app-staging.s3-website.us-east-2.amazonaws.com')) {
                this.environment = 'staging';
            }
            else if (window.location.hostname.includes('brainbuilder-rc.neurala.com')) {
                this.environment = 'releasecandidate';
            }
            else {
                this.environment = 'production';
            }
        }
        return this.environment;
    };
    API.prototype.isOnline = function () {
        return navigator.onLine;
    };
    API.prototype.isBrainBankLocalhost = function () {
        return this.baseURL.includes('localhost');
    };
    API.prototype.getParameterByName = function (name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        var results = regex.exec(url);
        if (!results) {
            return '';
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    API.prototype.getUserToken = function () {
        this.userToken = this.getParameterByName('token');
        return this.userToken;
    };
    API.prototype.endpoint = function () {
        return this.baseURL;
    };
    API.prototype.isLoggedIn = function () {
        return this.loggedIn;
    };
    API.prototype.getWheatleyToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.wheatleyToken) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.wheatleyProvider.getToken()];
                    case 1:
                        _a.wheatleyToken = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.wheatleyToken];
                }
            });
        });
    };
    /**
     * Creates the necessary headers for all requests
     * Other libraries like Resumable have no clue what HttpHeaders
     * are, so we just use an object to define the headers
     */
    API.prototype.createHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var wheatleyToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getWheatleyToken()];
                    case 1:
                        wheatleyToken = _a.sent();
                        // create a header with token when avaiable
                        return [2 /*return*/, wheatleyToken ? { Authorization: "WheatleyToken " + wheatleyToken } : {}];
                }
            });
        });
    };
    API.prototype.handleError = function (err) {
        var _this = this;
        // If BrainBank fails, send to error page
        if (this.getEnvironment() == 'onpremiseelectron') {
            if (err.status == 0) {
                setTimeout(function () {
                    /**
                     * See BB-5414
                     * If we get a status of 0 it means either BrainBank is unresponsive
                     * or a request is taking too long and BrainBuilder hangs up the connection.
                     * Run a healthcheck so we can see if BrainBank is actually unresponsive or
                     * if it is just a single bad response.  Then the onpremiseProvider can manage
                     * the details of what to do.
                     */
                    _this.onPremiseProvider.healthcheck();
                }, 0);
            }
        }
        throw err;
    };
    /**
     * Creates a GET request on the Neurala API
     * @param endpoint: string - API Endpoint that request should be pointed at
     */
    API.prototype.get = function (endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b, _c, _d;
                                return __generator(this, function (_e) {
                                    switch (_e.label) {
                                        case 0:
                                            _b = (_a = this.http).get;
                                            _c = [this.baseURL + "/" + endpoint];
                                            _d = {};
                                            return [4 /*yield*/, this.createHeaders()];
                                        case 1:
                                            _b.apply(_a, _c.concat([(_d.headers = _e.sent(),
                                                    _d)]))
                                                .subscribe(function (data) { return (data.success ? resolve(data) : reject(data)); }, function (err) { return reject(err); });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        this.handleError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a POST request on the Neurala API
     * @param endpoint: string - API Endpoint that request should be pointed at
     * @param payload: Object - Any data to be supplied in the POST request
     */
    API.prototype.post = function (endpoint, payload) {
        if (payload === void 0) { payload = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b, _c, _d;
                                return __generator(this, function (_e) {
                                    switch (_e.label) {
                                        case 0:
                                            _b = (_a = this.http).post;
                                            _c = [this.baseURL + "/" + endpoint, payload];
                                            _d = {};
                                            return [4 /*yield*/, this.createHeaders()];
                                        case 1:
                                            _b.apply(_a, _c.concat([(_d.headers = _e.sent(),
                                                    _d)]))
                                                .subscribe(function (data) { return (data.success ? resolve(data) : reject(data)); }, function (err) { return reject(err); });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_2 = _a.sent();
                        this.handleError(err_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a PATCH request on the Neurala API
     * @param endpoint: string - API Endpoint that request should be pointed at
     * @param payload: Object - Any data to be supplied in the PATCH request
     */
    API.prototype.patch = function (endpoint, payload) {
        if (payload === void 0) { payload = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b, _c, _d;
                                return __generator(this, function (_e) {
                                    switch (_e.label) {
                                        case 0:
                                            _b = (_a = this.http).patch;
                                            _c = [this.baseURL + "/" + endpoint, payload];
                                            _d = {};
                                            return [4 /*yield*/, this.createHeaders()];
                                        case 1:
                                            _b.apply(_a, _c.concat([(_d.headers = _e.sent(),
                                                    _d)]))
                                                .subscribe(function (data) { return (data.success ? resolve(data) : reject(data)); }, function (err) { return reject(err); });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_3 = _a.sent();
                        this.handleError(err_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a DELETE request on the Neurala API
     * @param endpoint: string - API Endpoint that request should be pointed at
     */
    API.prototype.delete = function (endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b, _c, _d;
                                return __generator(this, function (_e) {
                                    switch (_e.label) {
                                        case 0:
                                            _b = (_a = this.http).delete;
                                            _c = [this.baseURL + "/" + endpoint];
                                            _d = {};
                                            return [4 /*yield*/, this.createHeaders()];
                                        case 1:
                                            _b.apply(_a, _c.concat([(_d.headers = _e.sent(),
                                                    _d)]))
                                                .subscribe(function (data) { return (data.success ? resolve(data) : reject(data)); }, function (err) { return reject(err); });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_4 = _a.sent();
                        this.handleError(err_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a PUT request on the Neurala API
     * @param endpoint: string - API Endpoint that request should be pointed at
     * @param payload: Object - Any data to be supplied in the PUT request
     */
    API.prototype.put = function (endpoint, payload) {
        if (payload === void 0) { payload = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b, _c, _d;
                                return __generator(this, function (_e) {
                                    switch (_e.label) {
                                        case 0:
                                            _b = (_a = this.http).put;
                                            _c = [this.baseURL + "/" + endpoint, payload];
                                            _d = {};
                                            return [4 /*yield*/, this.createHeaders()];
                                        case 1:
                                            _b.apply(_a, _c.concat([(_d.headers = _e.sent(),
                                                    _d)]))
                                                .subscribe(function (data) { return (data.success ? resolve(data) : reject(data)); }, function (err) { return reject(err); });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_5 = _a.sent();
                        this.handleError(err_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles all error reporting to the user
     * @param err: Error object to be logged to the console in dev
     * @param title: Alert modal title
     * @param message: Alert modal message
     */
    API.prototype.errorHandler = function (err, title, message) {
        if (this.dev) {
            console.log(err);
        }
        this.modalProvider.presentError(title, message, undefined, this.translate.instant('OK'));
        throw err;
    };
    /**
     * Removes apikey of the user from angular session and cookie
     */
    API.prototype.resetInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wheatleyProvider.deleteToken()];
                    case 1:
                        _a.sent();
                        this.wheatleyToken = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Logs a user into the Wheatley Service
     * @param email - Email address for account
     * @param password - Password for account
     *
     * @return any - Response to login request
     */
    API.prototype.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var login, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.post('auth', {
                                email: email,
                                password: password
                            })];
                    case 1:
                        login = _a.sent();
                        // Set Api token for other requests
                        return [4 /*yield*/, this.setWheatleyToken(login.message)];
                    case 2:
                        // Set Api token for other requests
                        _a.sent();
                        return [2 /*return*/, login];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1.status == 403) {
                            this.errorHandler(e_1, this.translate.instant('Access Denied'), this.translate.instant('Sorry, but it looks like your account has been deactivated. Please contact your administrator.'));
                        }
                        else if (e_1.status == 429) {
                            throw e_1;
                        }
                        else if (e_1.status < 500 && e_1.status >= 400) {
                            this.errorHandler(e_1, this.translate.instant('Invalid Login'), this.translate.instant('Your email or password is incorrect.'));
                        }
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    API.prototype.setWheatleyToken = function (newToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.wheatleyToken = newToken;
                this.wheatleyProvider.setToken(newToken);
                this.loggedIn = true;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Attempt to create a Brain Builder account
     */
    API.prototype.register = function (userObject) {
        return __awaiter(this, void 0, void 0, function () {
            var err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userObject.token = this.userToken;
                        return [4 /*yield*/, this.post('users', userObject)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_6 = _a.sent();
                        this.errorHandler(err_6, 'Error', err_6.error.message);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Attempt to create a onpremise Brain Builder account
     */
    API.prototype.registerOnpremise = function (userObject) {
        return __awaiter(this, void 0, void 0, function () {
            var err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userObject.token = this.userToken;
                        return [4 /*yield*/, this.post('onpremise/users', userObject)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_7 = _a.sent();
                        throw err_7.error;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * join organization and migrate data
     */
    API.prototype.joinOrganization = function (userObject) {
        return __awaiter(this, void 0, void 0, function () {
            var err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userObject.token = this.userToken;
                        return [4 /*yield*/, this.post('organization/join', userObject)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_8 = _a.sent();
                        this.errorHandler(err_8, 'Error', err_8.error.message);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    API.prototype.validateUserToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.post('token/validate', { token: token })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_9 = _a.sent();
                        throw err_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Logs a user into Brain Bank application using authorization token
     *
     * @return NeuralaReponse - Response to validate token request
     */
    API.prototype.validateToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, result, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getWheatleyToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            throw new Error('no-token');
                        }
                        return [4 /*yield*/, this.post('auth/validate')];
                    case 2:
                        result = _a.sent();
                        this.loggedIn = true;
                        return [2 /*return*/, result];
                    case 3:
                        e_2 = _a.sent();
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    API = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpClient,
            Platform,
            ModalProvider,
            OnPremiseProvider,
            WheatleyProvider,
            TranslateService])
    ], API);
    return API;
}());
export { API };
//# sourceMappingURL=api.js.map


// WEBPACK FOOTER //
// ./src/providers/api.ts.pre-build-optimizer.js